export const STORAGE_CONSTANTS = {
  BEFORE_PHOTOS_SEARCH_PATHNAME: 'before_photos_search'
}